import { jsx as _jsx } from "react/jsx-runtime";
import { useReveal } from './reveal.context';
export const RevealContent = ({ children, revealId, }) => {
    const { activeReveal } = useReveal();
    const isActive = activeReveal === revealId;
    return isActive ? (_jsx("div", { "aria-describedby": `reveal-trigger-${revealId}`, id: `reveal-content-${revealId}`, "data-testid": "reveal-content", children: children })) : null;
};
//# sourceMappingURL=reveal.content.js.map